export enum LastOnBoardStatesEnum {
  Yes = 'Yes',
  No = 'No',
  Never = 'Never',
}
